import { combineReducers } from 'redux'

import deleteNode from './maintenances/delete'
import get from './maintenances/get'
import list from './maintenances/list'
import post from './maintenances/post'
import put from './maintenances/put'
import view from './maintenances/view'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put,
  view
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/maintenances.js